import React, { SVGProps } from 'react';

export const PreviewIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.292 3.333V7.5a.625.625 0 0 1-1.25 0V4.842l-6.433 6.434a.624.624 0 1 1-.884-.884l6.433-6.434H12.5a.625.625 0 0 1 0-1.25h4.167a.626.626 0 0 1 .625.625Zm-.625 6.875a.625.625 0 0 0-.625.625v3.334c0 1.314-.561 1.875-1.875 1.875H5.833c-1.314 0-1.875-.561-1.875-1.875V5.833c0-1.314.561-1.875 1.875-1.875h3.334a.625.625 0 0 0 0-1.25H5.834c-2.015 0-3.125 1.11-3.125 3.125v8.334c0 2.015 1.11 3.125 3.124 3.125h8.334c2.015 0 3.125-1.11 3.125-3.125v-3.334a.625.625 0 0 0-.625-.625Z"
      />
    </svg>
  );
};
